
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Wrench } from 'lucide-react';

interface AdminGamesHeaderProps {
  onAddNewGame: () => void;
  onToggleTools?: () => void;
  showTools?: boolean;
}

const AdminGamesHeader: React.FC<AdminGamesHeaderProps> = ({ 
  onAddNewGame, 
  onToggleTools,
  showTools = false 
}) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-2xl font-bold">Games Management</h1>
        <p className="text-gray-600">Manage your game collection</p>
      </div>
      <div className="flex items-center gap-2">
        {onToggleTools && (
          <Button
            variant={showTools ? "default" : "outline"}
            onClick={onToggleTools}
            className="flex items-center gap-2"
          >
            <Wrench className="w-4 h-4" />
            {showTools ? 'Hide Tools' : 'Show Tools'}
          </Button>
        )}
        <Button onClick={onAddNewGame} className="flex items-center gap-2">
          <Plus className="w-4 h-4" />
          Add New Game
        </Button>
      </div>
    </div>
  );
};

export default AdminGamesHeader;
